import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from '@/components/layout/app-shell';
import { HomePage } from '@/pages/home-page';
import { JoinPage } from '@/pages/join-page';
import { PlayPage } from '@/pages/play-page';
import { CguPage } from '@/pages/legal/cgu-page';
import { PrivacyPage } from '@/pages/legal/privacy-page';
import { MentionsPage } from '@/pages/legal/mentions-page';
import { AdminPage } from '@/pages/admin-page';

function App() {
  return (
    <BrowserRouter>
      <AppShell>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/s/:shortCode" element={<JoinPage />} />
          <Route path="/play/:shortCode" element={<PlayPage />} />
          <Route path="/legal/cgu" element={<CguPage />} />
          <Route path="/legal/confidentialite" element={<PrivacyPage />} />
          <Route path="/legal/mentions" element={<MentionsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}

export default App;
